export const accent = '#2C3454';
